<template>
  <div class="summary-stat">
    <el-breadcrumb class="admin-path" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>系统统计</el-breadcrumb-item>
      <el-breadcrumb-item>数据下载排行统计</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row :gutter="12">
      <el-col :span="12">
        <el-card class="user-card">
          <div slot="header" class="clearfix">
            <span>用户下载量排行</span>
          </div>
          <div class="container">
            <!-- <el-form :inline="true" :model="searchParams" class="search-form">
              <el-form-item label="用户邮箱">
                <el-autocomplete
                class="inline-input"
                  placeholder=""
                  style="width: 220px"
                  v-model="searchParams.email"
                  :fetch-suggestions="proquerySearch"
                  :trigger-on-focus="false"
                  clearable>
                </el-autocomplete>
              </el-form-item>
              <el-form-item>
                <el-button size='mini' type="primary" @click="onSubmit">查询</el-button>
              </el-form-item>
            </el-form> -->
            <el-table
              :data="userlist"
              style="width: 100%"
              @sort-change="usersortChange">
              <el-table-column
                type="selection"
                width="55"
                v-if="false">
              </el-table-column>
              <el-table-column
                prop="id"
                label="id"
                v-if="false">
              </el-table-column>
              <el-table-column
                prop="email"
                sortable="custom"
                label="邮箱">
              </el-table-column>
              <el-table-column
                prop="user_id"
                sortable="custom"
                label="用户ID">
              </el-table-column>
              <el-table-column
                prop="filenum"
                sortable="custom"
                label="下载文件数">
              </el-table-column>
              <el-table-column
                prop="downcount"
                sortable="custom"
                label="下载量合计">
              </el-table-column>
            </el-table>

            <el-pagination
              background
              layout="total, sizes, prev, pager, next, jumper"
              :current-page.sync="usercurrentPage"
              :page-size.sync="userpageSize"
              :total="usertotal"
              @size-change="UsersizeChange"
              @current-change="UserchangePage">
            </el-pagination>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="data-card">
          <div slot="header" class="clearfix">
            <span>文件下载量排行</span>
          </div>
          <div class="container">
            <!-- <el-form :inline="true" :model="searchParams" class="search-form">
              <el-form-item  label="数据类别">
                <el-select  size="mini" v-model="searchParams.type" style="width:200px;" 
                            filterable placeholder="Proposal/GRB/SEM/UPK" clearable >
                        <el-option
                            v-for="item in filedataltype"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="数据ID">
                <el-autocomplete
                class="inline-input"
                  placeholder=""
                  style="width: 220px"
                  v-model="searchParams.ogs_id"
                  :fetch-suggestions="querySearch"
                  :trigger-on-focus="false"
                  clearable>
                </el-autocomplete>
              </el-form-item>
              <el-form-item label="用户邮箱">
                <el-autocomplete
                class="inline-input"
                  placeholder=""
                  style="width: 220px"
                  v-model="searchParams.email"
                  :fetch-suggestions="proquerySearch"
                  :trigger-on-focus="false"
                  clearable>
                </el-autocomplete>
              </el-form-item>
              <el-form-item>
                <el-button size='mini' type="primary" @click="onSubmit">查询</el-button>
              </el-form-item>
            </el-form> -->
            <el-table
              :data="datalist"
              style="width: 100%"
              @sort-change="sortChange">
              <el-table-column
                type="selection"
                width="55"
                v-if="false">
              </el-table-column>
              <el-table-column
                prop="id"
                label="id"
                v-if="false">
              </el-table-column>
              <el-table-column
                prop="type"
                sortable="custom"
                label="类别">
              </el-table-column>
              <el-table-column
                prop="ogs_id"
                sortable="custom"
                label="数据ID">
              </el-table-column>
              <el-table-column
                prop="level"
                sortable="custom"
                label="数据级别">
              </el-table-column>
              <el-table-column
                prop="file_id"
                sortable="custom"
                label="文件ID">
              </el-table-column>
              <el-table-column
                prop="file_len"
                sortable="custom"
                label="文件长度">
              </el-table-column>

              <el-table-column
                prop="downcount"
                sortable="custom"
                label="下载次数累计">
              </el-table-column>
          
            </el-table>

            <el-pagination
              background
              layout="total, sizes, prev, pager, next, jumper"
              :current-page.sync="currentPage"
              :page-size.sync="pageSize"
              :total="total"
              @size-change="sizeChange"
              @current-change="changePage">
            </el-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {downfiletype} from '../common';
import axios from 'axios';

export default {
  name: 'SummaryUserData',
  data() {
    return {
      searchParams: {
        ogs_id: '',
        email:'',
        type:'',
      },
      userlist: [],
      datalist: [],
      usercurrentPage: 1,
      userpageSize: 20,
      usertotal: 0,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      userorderDirection: null,
      userorderProp: '',
      orderDirection: null,
      orderProp: '',
      filedataltype: downfiletype,
      restaurants:[],
      prorestaurants:[],
    };
  },
  created() {
    this.getData();
    // this.getinitlist();
  },
  methods: {
    getData() {
      const params = {
        usercurrentPage: this.usercurrentPage,
        userpageSize: this.userpageSize,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        // ...this.searchParams,
      }
      axios.post('/iapi/getsummyuserdata',params).then((res) => {
        if (res.data.errcode === 0) {
          this.userlist = res.data.userdata.userlist;
          this.usertotal = res.data.userdata.usertotal;
          this.datalist = res.data.datadata.list;
          this.total = res.data.datadata.total;
        }
      });
      // console.log("authstates",this.currentastates);
    },
    getUserData(){
      const params = {
        usercurrentPage: this.usercurrentPage,
        userpageSize: this.userpageSize,
        // ...this.searchParams,
      };
      if (this.userorderDirection && this.userorderProp) {
        params.userorderDirection = this.userorderDirection;
        params.userorderProp = this.userorderProp;
      }
      axios.post('/iapi/getsummyuser',params).then((res) => {
        if (res.data.errcode === 0) {
          this.userlist = res.data.data.list;
          this.usertotal = res.data.data.total;
        }
      });
    },
    getDataData(){
      const params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        // ...this.searchParams,
      };
      if (this.orderDirection && this.orderProp) {
        params.orderDirection = this.orderDirection;
        params.orderProp = this.orderProp;
      }
      axios.post('/iapi/getsummydata',params).then((res) => {
        if (res.data.errcode === 0) {
          this.datalist = res.data.data.list;
          this.total = res.data.data.total;
        }
      });

    },
    // onSubmit() {
    //   this.getData();
    // },
    UsersizeChange() {
      this.getUserData();
    },
    UserchangePage(page) {
      this.usercurrentPage = page;
      this.getUserData();
    },
    sizeChange() {
      this.getDataData();
    },
    changePage(page) {
      this.currentPage = page;
      this.getDataData();
    },

    querySearch(queryString, cb) {
      let restaurants = this.restaurants;
      let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0);
      };
    },
    proquerySearch(queryString, cb) {
      let prorestaurants = this.prorestaurants;
      let results = queryString ? prorestaurants.filter(this.procreateFilter(queryString)) : prorestaurants;
      cb(results);
    },
    procreateFilter(queryString) {
      return (prorestaurants) => {
        return (prorestaurants.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0);
      };
    },
    usersortChange(param) {
      this.userorderDirection = param.order;
      this.userorderProp = param.prop;
      this.usercurrentPage = 1;
      this.getUserData();
    },
    sortChange(param) {
      this.orderDirection = param.order;
      this.orderProp = param.prop;
      this.currentPage = 1;
      this.getDataData();
    },
    // getinitlist(){
    //   axios.post('/iapi/getinitlist').then((res) => {
    //     if (res.data.errcode === 0) {
    //       this.restaurants = res.data.ogsid;
    //       this.prorestaurants = res.data.email;
    //     }
    //   });
    // },
  },
};
</script>

<style scoped>
.summary-stat {
  padding: 24px 56px;
}
.container {
  background: #fff;
  border-radius: 2px;
}
.search-form {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.el-form-item {
    color: blue;
    margin-top: 0px;
    margin-bottom: 0px;
}
.admin-path {
  margin-bottom: 16px;
}
</style>